import React, { useMemo } from "react"
import { flowRight as compose } from "lodash"
import {
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  CardHeader,
  CardFooter,
  Alert
} from "reactstrap"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { withRouter } from "react-router"
import { BackButton } from "components/utility"
import { BarLoader } from "components/spinner"
import { areaTypes } from "utils/types"
import useData from "./useData"

const CompanyForm = props => {
  const {
    loading,
    error,
    createData,
    updateData,
    checkRequire,
    companyData,
    writeData
  } = useData(props.match.params.id)

  useBread({
    to: props.match.url,
    name: props.match.params.id ? "維護公司" : "新增公司"
  })

  const renderSaveButton = () => {
    return (
      <Button
        color="primary"
        disabled={checkRequire(companyData)}
        onClick={() => {
          if (props.match.params.id) {
            updateData(companyData, () => {
              props.history.goBack()
            })
          } else {
            createData(companyData, () => {
              props.history.goBack()
            })
          }
        }}
      >
        送出
      </Button>
    )
  }

  const renderAreaOptions = useMemo(() => {
    return companyData?.area === "ALL" ? (
      <option value="ALL">全區</option>
    ) : (
      <>
        {areaTypes
          .filter(item => item.key !== "ALL")
          .map(item => (
            <option key={item.key} value={item.key}>
              {item.value}
            </option>
          ))}
      </>
    )
  }, [companyData])

  return (
    <div className="">
      <Card>
        <CardHeader>
          <BackButton left />
        </CardHeader>
        <CardBody>
          <Form
            style={{
              marginLeft: "10px",
              marginRight: "10px"
            }}
          >
            <FormGroup row>
              <Label for="name">公司名稱 *</Label>
              <Input
                type="text"
                name="name"
                id="name"
                placeholder="名稱"
                value={companyData?.name || ""}
                onChange={e => writeData("name", e.target.value)}
              />
            </FormGroup>
            <FormGroup row>
              <Label for="area">所屬區域 *</Label>
              <Input
                type="select"
                name="area"
                id="area"
                value={companyData?.area || ""}
                onChange={e => writeData("area", e.target.value)}
              >
                <option value="">請選擇所屬區域</option>
                {renderAreaOptions}
              </Input>
            </FormGroup>
            <FormGroup row>
              <Label for="address">地址 *</Label>
              <Input
                type="text"
                name="address"
                id="address"
                placeholder="地址"
                value={companyData?.address || ""}
                onChange={e => writeData("address", e.target.value)}
              />
            </FormGroup>
            <FormGroup row>
              <Label for="phoneNumber">電話 *</Label>
              <Input
                type="text"
                name="phoneNumber"
                id="phoneNumber"
                placeholder="電話"
                value={companyData?.phoneNumber || ""}
                onChange={e => writeData("phoneNumber", e.target.value)}
              />
            </FormGroup>
            <FormGroup row>
              <Label for="content">電郵 </Label>
              <Input
                type="email"
                name="email"
                id="email"
                placeholder="電郵"
                value={companyData?.email}
                onChange={e => writeData("email", e.target.value)}
              />
            </FormGroup>
            <FormGroup row>
              <Label for="companyNumber">統編 *</Label>
              <Input
                type="number"
                name="companyNumber"
                id="companyNumber"
                placeholder="統編"
                value={companyData?.companyNumber || ""}
                onChange={e => writeData("companyNumber", e.target.value)}
              />
            </FormGroup>
          </Form>
        </CardBody>
        <CardFooter>
          <div>{renderSaveButton()}</div>
        </CardFooter>
        <BarLoader loading={loading} />
      </Card>
      {error !== undefined && (
        <Alert color="danger">錯誤訊息：{`${error}`}</Alert>
      )}
    </div>
  )
}

export default compose(withBreadcrumb, withRouter)(CompanyForm)
